import PaymentSection from 'components/GlobalModals/PaidReservationModal/PaymentSection/PaymentSection';

export default PaymentSection;
